import Vue from 'vue'

import {JCounter} from './JCounter'
Vue.component('j-counter', JCounter)

import JCard from './JCard'
Vue.component('j-card', JCard)

import JNotifications from './JNotifications'
Vue.component('j-notifications', JNotifications)

import JCreateOrEditForm from './JCreateOrEditForm'
Vue.component('j-create-or-edit-form', JCreateOrEditForm)

import JGridAlpha from './JGridAlpha'
Vue.component('j-grid-alpha', JGridAlpha)

import JGridIndexActions from './JGridIndexActions'
Vue.component('j-grid-index-actions', JGridIndexActions)
